import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'

import { useSelector, useDispatch } from 'react-redux'

import mapboxgl from 'mapbox-gl';

const EMPTY_GEOJSON_DATA = {
  "type": "Feature", "properties": { "icon": "marker1" },
  "geometry": { "type": "Point", "coordinates": [] }
}


/**
 * Draws and removes the markers on the map, extracting relevant parts
 * from the the json definition 
 *  
 */
export default function ExtraMapMarkerFeatures(props) {

  const map = useSelector((state) => state.ui.map) ;

  const features = useSelector((state) => state.viewport.extraMapFeatures) ;
  const featuresVisibility = useSelector((state) => state.viewport.extraMapFeaturesVisibility)

  const mapStyle = useSelector((state) => state.ui.mapStyle) ;

  // to check if initialization was done
  const isInitializedRef = useRef(false)
  const isInitiallyZoomedRef = useRef(false)  
  
  const popupRef = useRef(null)  

  // popup event listeners:
  const displayPopup = (e) => {
    // if (popupRef.current) popupRef.current.remove()
    if (! popupRef.current) {       
      popupRef.current = new mapboxgl.Popup({
        anchor: 'top'
      })
    }
    popupRef.current.remove()
    const feature = e.features[0] ;
    const coordinates = feature.geometry.coordinates.slice();
    // Ensure that if the props.map is zoomed out such that multiple copies of the feature are visible,
    // the popup appears over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }
    popupRef.current.setLngLat(coordinates)
            .setHTML(feature.properties.description).addTo(map);      
  }
  // Change the cursor to a pointer when the mouse is over the places layer.
  const changeCursor = () => {
    map.getCanvas().style.cursor = 'pointer';
  }
  // Change it back to a pointer when it leaves.
  const changeCursorBack = () => {
    map.getCanvas().style.cursor = '';
  }
  
  // initialization / descruction: 
  useEffect(() => {

    var featuresOfLayers = {}
    
    if ( map && features && Object.keys(features).length > 0) {
      //  collect markers 
      // layerId -> (latlon key) -> features
      for (var i = 0; i < features.items.length; i++) {
        const item = features.items[i] 
        // all map layer items defined: 
        if (featuresVisibility[item.key]) {
          // all marker sets defined:  
          if (item.hasOwnProperty('markers')) {
            for (let j = 0; j < item.markers.length; j++ ) { 
              const layerId = item.markers[j].layerId 
              const locations = item.markers[j].locations 
              var featuresOnaLayer = featuresOfLayers[layerId]
              if (! featuresOnaLayer) featuresOnaLayer = {}
              // all markers defined: 
              for (let k = 0; k < locations.length; k++ ) {
                const latlonkey = locations[k][0] + ',' + locations[k][1]
                // features are assigned to a coordinate - they can overwrite each other
                featuresOnaLayer[latlonkey] = {
                  "type": "Feature",
                  "properties": {
                    "description": locations[k][2],
                    "label": locations[k][3]
                  },
                  "geometry": {
                    "type": "Point",
                    "coordinates": [locations[k][0], locations[k][1]]
                  }
                }
              } 
              featuresOfLayers[layerId] = featuresOnaLayer 
            }
          }
        }
      }

      // re-set source data 
      // const markers = collectMarkers(wpLayers.items)
      for (const [lkey, lvalue] of Object.entries(featuresOfLayers)) {
        
        var cpsSourceData = {
          "type": "FeatureCollection",
          "features": []
        }
        for (const lv in lvalue) {
          cpsSourceData.features.push(lvalue[lv]) 
        }
        if ( map ) {
          const src = map.getSource(lkey)
          if (typeof src !== 'undefined')           
            src.setData(cpsSourceData);
        }
      }
      //// if there are no visible markers: 
      //if (Object.keys(featuresOfLayers).length == 0) {
      //  for (var i = 0; i < wpLayers.layers.length; i++) {
      //    
      //  }
      //}
      
    }
    
    // event listeners 
    if (Object.keys(featuresOfLayers).length > 0) {
      // if there were objects on the marker layers
      for (var i = 0; i < Object.keys(featuresOfLayers).length; i++) {
        const layerId = Object.keys(featuresOfLayers)[i] ;
        map.on('click', layerId, displayPopup);          
        map.on('mouseenter', layerId, changeCursor);
        map.on('mouseleave', layerId, changeCursorBack) ;

        // TODO: moving layer should be separated to a map component
        //map.moveLayer(layerId)
      }
    }
      // FIX not working: reordering layers 
      // console.log('ExtraMapLineFeatures: moving routes layer to top.')
      // map.moveLayer('routes')
    
    return () => {
      if (Object.keys(featuresOfLayers).length > 0) {
        for (var i = 0; i < Object.keys(featuresOfLayers).length; i++) {
          // if there were objects on the marker layers
          const layerId = Object.keys(featuresOfLayers)[i] ;  
          map.off('click', layerId, displayPopup);          
          map.off('mouseenter', layerId, changeCursor);
          map.off('mouseleave', layerId, changeCursorBack) ;
          
          // remove source data 
          try {
            map.getSource(layerId).setData( EMPTY_GEOJSON_DATA) ;
          } catch (error) {
          }          
        }
      }
  
    }

  }, [map, features, featuresVisibility]);


  return null ;
}

